<template>
  <div>人车多次事故</div>
</template>

<script>
export default {
name:'',
data(){
return {};
}
};

</script>
<style  lang="scss" scoped>
</style>